import { useCheckPermissions } from '@/shared';
import { SaveMarcaProducto } from '../../shared/saveMarcasProduct';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateMarcaPeoductoPageInterface {}

const CreateMarcaProductoPage: React.FC<CreateMarcaPeoductoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_marca_producto)

  return <SaveMarcaProducto titlePage="Crear Marca Producto" />;
};

export default CreateMarcaProductoPage;
